// define used error code
export enum ErrorCode {
  NotResponse = -1,
  ServerError = 10000
}

// define used error message (lang key)
export const ErrorMessage = {
  [ErrorCode.ServerError]: "server_error"
};
